class HeroVideoSlideshow extends HTMLElement {
  constructor() {
    super()
    this.current = 0
    this.intervalId = null
    this.displayDuration = 5500
    this.transitionDuration = 600
    this._onSectionLoad = this.handleSectionLoad.bind(this)
  }

  connectedCallback() {
    this.init()
    document.addEventListener("shopify:section:load", this._onSectionLoad)
  }

  disconnectedCallback() {
    this.stopSlideshow()
    document.removeEventListener("shopify:section:load", this._onSectionLoad)
  }

  init() {
    this.stopSlideshow()
    // Accent bar fill (CSS) tracks how long each slide is shown.
    this.style.setProperty("--hero-slide-duration", `${this.displayDuration}ms`)
    this.slides = Array.from(this.querySelectorAll(".hero-video__slide"))
    if (this.slides.length === 0) return

    this.current = 0

    // Reset classes
    this.slides.forEach(slide => {
      slide.classList.remove("active", "enter", "exit")
    })

    // Initialize first slide
    this.slides[this.current].classList.add("active", "enter")
    setTimeout(() => {
      if (this.slides && this.slides[this.current]) {
        this.slides[this.current].classList.remove("enter")
      }
    }, 50)

    if (this.slides.length <= 1) return

    this.startSlideshow()
  }

  startSlideshow() {
    this.stopSlideshow()
    this.intervalId = setInterval(() => {
      const currentSlide = this.slides[this.current]
      if (!currentSlide) return

      currentSlide.classList.add("exit")
      currentSlide.classList.remove("active")

      setTimeout(() => {
        currentSlide.classList.remove("exit")

        this.current = (this.current + 1) % this.slides.length
        const nextSlide = this.slides[this.current]
        if (!nextSlide) return

        nextSlide.classList.add("active", "enter")

        setTimeout(() => {
          nextSlide.classList.remove("enter")
        }, 50)
      }, this.transitionDuration)
    }, this.displayDuration + this.transitionDuration)
  }

  stopSlideshow() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  handleSectionLoad(event) {
    if (
      (event.target && event.target.contains(this)) ||
      (event.detail && event.detail.sectionId && this.closest(`#shopify-section-${event.detail.sectionId}`))
    ) {
      this.init()
    }
  }
}

if (!customElements.get("hero-video-slideshow")) {
  customElements.define("hero-video-slideshow", HeroVideoSlideshow)
}
